<label>
  <input type="checkbox">
  {{name}}
</label>
